import { render, staticRenderFns } from "./ComplainceTransLimit.vue?vue&type=template&id=2df90720&scoped=true"
import script from "./ComplainceTransLimit.vue?vue&type=script&lang=js"
export * from "./ComplainceTransLimit.vue?vue&type=script&lang=js"
import style0 from "./ComplainceTransLimit.vue?vue&type=style&index=0&id=2df90720&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df90720",
  null
  
)

export default component.exports